export default __webpack_public_path__ + "static/media/dalfinternationalacademy.b1894b9b.png";